var render, staticRenderFns
import script from "./KButton.vue?vue&type=script&lang=js"
export * from "./KButton.vue?vue&type=script&lang=js"
import style0 from "./KButton.vue?vue&type=style&index=0&id=2a7f8966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f8966",
  null
  
)

export default component.exports